module.exports = __webpack_public_path__ + "img/chart-bar-hori-single.ecc790f1.svg";